import { useState } from "react";
import { data } from "../../../data/mockPlans";

export function useDeletePlan() {
  const [isDeletePlanLoading, setIsPlanLoading] = useState(false);
  const deletePlan = async (id: number) => {
    try {
      setIsPlanLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      // const response = await api.delete("company/locator/list/id");  //example
      const newData = data.filter((data) => data.id !== id);
      return newData;
    } catch (error) {
      throw error;
    } finally {
      setIsPlanLoading(false);
    }
  };

  return { deletePlan, isDeletePlanLoading };
}
